/**
 * OpenStreetMap Nominatim search (browser). Respect usage policy: low volume, identify app.
 * https://operations.osmfoundation.org/policies/nominatim/
 */
export async function nominatimSearch(
    query: string
): Promise<{ lat: number; lon: number; displayName: string } | null> {
    const q = query.trim();
    if (!q) return null;

    const url =
        "https://nominatim.openstreetmap.org/search?" +
        new URLSearchParams({
            format: "json",
            limit: "1",
            q,
        }).toString();

    const res = await fetch(url, {
        headers: {
            Accept: "application/json",
        },
    });

    if (!res.ok) {
        throw new Error(`Geocoding request failed (${res.status})`);
    }

    const data = (await res.json()) as Array<{ lat: string; lon: string; display_name?: string }>;
    if (!data?.length) return null;

    const row = data[0];
    const lat = Number(row.lat);
    const lon = Number(row.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;

    return {
        lat,
        lon,
        displayName: row.display_name ?? q,
    };
}
